<template>
  <div class="asset-more-info">
    <div class="px-4">
      <div class="text-sm text-text-ternary mb-2">{{ $t('result') }}</div>
      <div class="divide-y divide-border -mx-4 text-sm">
        <AssetMoreInfoItem :name="$t('profit')"
                           money-format
                           :currency="currency"
                           :value="+asset.profit_absolute"
                           :percent="+asset.profit_percent"
                           :highlight-values="true"/>
        <AssetMoreInfoItem :name="$t('yield')"
                           :percent="0"
                           :highlight-values="true"/>
      </div>
    </div>
    <div class="px-4">
      <div class="text-sm text-text-ternary mb-2">{{ $t('finances') }}</div>
      <div class="divide-y divide-border -mx-4 text-sm">
        <AssetMoreInfoItem :name="$t('deals')"
                           money-format
                           :currency="currency"
                           :value="0"
                           :percent="0"
                           :highlight-values="true"/>
        <AssetMoreInfoItem :name="$t('dividends')"
                           money-format
                           :currency="currency"
                           :value="0"
                           :percent="0"
                           :highlight-values="true"/>
        <AssetMoreInfoItem :name="$t('commissions')"
                           money-format
                           :currency="currency"
                           :value="0"
                           :highlight-values="true"/>
      </div>
    </div>
    <div class="px-4">
      <div class="text-sm text-text-ternary mb-2">{{ $t('averagePrice') }}</div>
      <div class="divide-y divide-border -mx-4 text-sm">
        <AssetMoreInfoItem :name="$t('buys')"
                           :currency="currency"
                           money-format
                           hide-percentage
                           :value="asset.price_avg"/>
        <AssetMoreInfoItem :name="$t('sales')"
                           :currency="currency"
                           money-format
                           hide-percentage
                           :value="0"/>
      </div>
    </div>
    <div class="px-4">
      <div class="text-sm text-text-ternary mb-2">{{ $t('lots') }}</div>
      <div class="divide-y divide-border -mx-4 text-sm">
        <AssetMoreInfoItem :name="$t('totalLots')"
                           hide-percentage
                           :value="asset.amount"/>
        <AssetMoreInfoItem :name="$t('stocksInLots')"
                           hide-percentage
                           :value="1"/>
      </div>
    </div>
  </div>
</template>

<script>
import AssetMoreInfoItem from "@/components/cabinet/Investments/InvestmentAssets/InvestmentAssetItem/AssetMoreInfoItem";
import {mapGetters} from "vuex";

export default {
  name: "AssetMoreInfo",
  components: {AssetMoreInfoItem},
  props: {
    asset: {
      type: Object,
      required: true
    },
    currency:{
      type: Object,
      required: true
    }
  },
  i18n: {
    messages: {
      en: {
        result: 'Result',
        profit: 'Profit',
        yield: 'Yield',
        finances: 'Finances',
        deals: 'Deals',
        dividends: 'Dividends',
        commissions: 'Commissions',
        averagePrice: 'Average price',
        buys: 'Buys',
        sales: 'Sales',
        lots: 'Lots',
        totalLots: 'Total lots',
        stocksInLots: 'Shares per lot'
      },
      ru: {
        result: 'Результат',
        profit: 'Прибыль',
        yield: 'Доходность',
        finances: 'Финансы',
        deals: 'Сделки',
        dividends: 'Дивидиенды',
        commissions: 'Комиссии',
        averagePrice: 'Средняя цена',
        buys: 'Покупки',
        sales: 'Продажи',
        lots: 'Лоты',
        totalLots: 'Всего лотов',
        stocksInLots: 'Акций в лоте'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.asset-more-info {
  @apply bg-line relative -mb-px pt-8 pb-16
  grid justify-end items-start;
  padding-right: 34px;
  grid-template-columns: repeat(2, 245px) repeat(2, 195px);
  grid-column-gap: 4rem;

  &:before, &:after {
    content: '';
    @apply absolute w-full h-4 left-0;
    background: radial-gradient(50% 50% at 50% 0%, rgba(21, 62, 103, 0.09) 0%, rgba(21, 62, 103, 0) 100%);
  }

  &:before {
    @apply top-0;
  }

  &:after {
    @apply transform rotate-180 bottom-0;
  }

  @media(max-width: 1229px) {
    @apply justify-center px-16;
    grid-template-columns: repeat(2, 245px);
    grid-row-gap: 2rem;

  }
}

</style>